import styled, { keyframes } from 'styled-components';

import { REDUCED_MOTION, SPACE, TOAST, TOAST_ANIM, WEBSITE_ANALYTICS } from '../../../../theme/tokens';
import { contentAreaCenterX } from '../../../../theme/contentAreaOverlay';
import { Text } from '../../../../components';

/* The studio toast's layer and pill (components/Toast), so the two read as one family. */
export const Viewport = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  z-index: 2100; /* the toast's layer: above the area's sheets */
  display: flex;
  justify-content: center;
  padding: ${SPACE[0]} ${SPACE[16]};
  pointer-events: none;

  ${contentAreaCenterX}
`;

export const Pill = styled.div<{ $on: boolean }>`
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
  min-width: 240px;
  max-width: min(420px, calc(100vw - 32px));
  padding: 14px 22px; /* the toast's inset */
  border-radius: 12px;
  background: ${TOAST.bg};
  color: ${TOAST.text};
  box-shadow: ${TOAST.shadow};
  opacity: ${(p) => (p.$on ? 1 : 0)};
  transform: translateY(${(p) => (p.$on ? '0' : `${TOAST_ANIM.OFFSET_PX}px`)});
  transition:
    opacity ${(p) => (p.$on ? TOAST_ANIM.ENTER_MS : TOAST_ANIM.EXIT_MS)}ms ${TOAST_ANIM.EASE},
    transform ${(p) => (p.$on ? TOAST_ANIM.ENTER_MS : TOAST_ANIM.EXIT_MS)}ms ${TOAST_ANIM.EASE};
`;

export const Message = styled(Text)`
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: ${TOAST.text};
  text-align: center;
`;

/** The indeterminate bar: a track with a segment sweeping across it, for as long as the work runs. */
export const Track = styled.div`
  position: relative;
  height: 3px;
  border-radius: 999px;
  overflow: hidden;
  background: ${WEBSITE_ANALYTICS.barTrack};
`;

const sweep = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
`;

export const Runner = styled.span`
  position: absolute;
  inset: 0 auto 0 0;
  width: 40%;
  border-radius: inherit;
  background: ${WEBSITE_ANALYTICS.bar};
  animation: ${sweep} ${TOAST_ANIM.PROGRESS_SWEEP_MS}ms ${TOAST_ANIM.EASE} infinite;

  /* Reduced motion: a still, partly filled bar instead of the sweep. */
  ${REDUCED_MOTION} {
    animation: none;
    transform: translateX(75%);
  }
`;
